module.exports = __webpack_public_path__ + "img/s1_t1_05.8ab4b7c6.jpeg";